import React from 'react';
import { Divider, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import CopyButton from '../../common/controls/CopyButton';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import { removeZeroDecimals } from '../../../utils/removeZeroDecimals';

export default function InventoryTransactionView({setTransaction, handleEdit = null, open, onClose, transaction = null}) { 

    const { t } = useTranslation('common'); 

    const handleClose = () => {
        onClose();
    };

    const handleEditClick = () => {
        handleEdit(transaction);
    };

    if (!transaction) {
        return (
            <></>
        );
    }

    return (
        <React.Fragment>
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            
            <DialogTitle>Inventory Transaction</DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>{t('inventory.transactions.messages.no_edit_delete')}</Typography>
                <Divider sx={{my: 2}} />
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Reference Code</Typography>
                <Box display="inline-flex" alignItems="center">
                    <Typography variant="body1" sx={{ mt: 0 }}>{transaction.reference_code}</Typography>
                    { transaction.reference_code ? <CopyButton text={transaction.reference_code} /> : null }
                </Box>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Date</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{transaction.date}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Type</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{transaction.transactionType.name}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Item</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{transaction.item?.name || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Item Current Stock</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{`${removeZeroDecimals(transaction.item?.current_stock)}${transaction.item?.uom}`}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Patient</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{transaction.pet ? `${transaction.pet.name} (${transaction.pet.owner.last_name}, ${transaction.pet.owner.first_name})`  : "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Medical History</Typography>
                <Box display="inline-flex" alignItems="center">
                    <Typography variant="body1" sx={{ mt: 0 }}>{transaction.history ? `${transaction.history.case_number}`  : "(none)"}</Typography>
                    { transaction.history ? <CopyButton text={transaction.history.case_number} /> : null }
                </Box>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Procedure</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{transaction.historyEntry ? `${transaction.historyEntry.type.name}`  : "(none)"}</Typography>
                
                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Supplier</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{transaction.supplier?.name || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Quantity</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{`${transaction.flow === 'in' ? "+" : "-"}${removeZeroDecimals(transaction.quantity)}${transaction.item.uom}`}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Total Cost</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{`${transaction.total_cost} (${transaction.unit_cost_price}/${transaction.item.uom})`}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Total Price</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{`${transaction.total_selling} (${transaction.unit_selling_price}/${transaction.item.uom})`}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Remarks</Typography>
                <Typography variant="body1" sx={{ mt: 0 }}>{transaction?.remarks || "(none)"}</Typography>

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Created</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(transaction.createdAt)}</Typography>

                {/* <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>Last Updated</Typography> */}
                {/* <Typography variant="body2" sx={{ mt: 0 }}>{formatToLocalDateTime(transaction.updatedAt)}</Typography> */}

                <Typography variant="body2" sx={{ mb: 0, color: 'gray' }}>User</Typography>
                <Typography variant="body2" sx={{ mt: 0 }}>{transaction.user.name}</Typography>

            </DialogContent>
            <DialogActions>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
        </React.Fragment>
    );
}